import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useLocale } from '@bluebeam/react-i18n';
import { createCalendar } from '@internationalized/date';
import { useDateField } from '@react-aria/datepicker';
import { useDateFieldState } from '@react-stately/datepicker';
import { useRef } from 'react';
import DateSegment from './DateSegment';
const DateField = (props) => {
    const locale = useLocale();
    const state = useDateFieldState({ ...props, locale: locale.languageCode, createCalendar });
    const dateFieldRef = useRef(null);
    const { fieldProps } = useDateField(props, state, dateFieldRef);
    return (_jsx("div", { ...fieldProps, ref: dateFieldRef, className: buildClassName('skyline-text-body-1 flex grow'), onKeyDown: (e) => {
            if (fieldProps.onKeyDown)
                fieldProps.onKeyDown(e);
            if (e.key === 'Escape') {
                state.clearSegment('month');
                state.clearSegment('day');
                state.clearSegment('year');
                if (document.activeElement instanceof HTMLElement) {
                    document.activeElement.blur();
                }
            }
        }, children: state.segments.map((segment, i, array) => (_jsx(DateSegment, { className: buildClassName((i > 0 &&
                array[i - 1].type !== 'literal' &&
                array[i - 1].placeholder !== array[i - 1].text) ||
                (segment.text !== segment.placeholder && segment.type !== 'literal')
                ? 'text-black'
                : 'text-darker-gray', {
                'text-light-gray': state.isDisabled,
            }), segment: segment, state: state }, i))) }));
};
export default DateField;
//# sourceMappingURL=DateField.js.map